import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { BaseEntity } from '../../models/BaseEntity';
import { generatePullQuery, PullQueryContext } from '../queryBuilders/generatePullQuery';
import { defaultDocAllTime } from '../Shared/defaultDoc';

export interface Pass extends BaseEntity {
  readonly id: string;
  readonly description: string;
  readonly isActive: boolean;
  readonly miningMethod: string;
  readonly miningStyle: string;
}
export type PassesCollection = RxCollection<Pass> | null;
export type PassDocument = RxDocument<Pass>;

export const passesSchema: RxJsonSchema<Pass> = {
  type: 'object',
  version: 0,
  description: 'describes a Block object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    updatedAt: { type: 'number' },
    isActive: { type: 'boolean' },
    isDeleted: { type: 'boolean' },
    miningMethod: { type: 'string' },
    miningStyle: { type: 'string' },
    version: { type: 'number' },
  },
};

const passFeedQuery = print(gql`
  query passFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!) {
    passFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
      description
      id
      isActive
      isDeleted
      miningMethod
      miningStyle
      updatedAt
      version
    }
  }
`);

export const passesPullQueryBuilder = generatePullQuery(
  passFeedQuery,
  PullQueryContext.Site,
  defaultDocAllTime,
);
